import { SHARE_OPTION_GROUPS, shareOptionNeedsScene, type ShareOptions } from '../../utils/shareLink';
import styles from './ShareAccessOptions.module.css';

interface ShareAccessOptionsProps {
  value: ShareOptions;
  onChange: (next: ShareOptions) => void;
}

const ShareAccessOptions = ({ value, onChange }: ShareAccessOptionsProps) => (
  <div className={styles.root}>
    <p className={styles.heading}>Access Options</p>
    {SHARE_OPTION_GROUPS.map((group) => (
      <div key={group.title ?? 'link'} className={styles.group}>
        {group.title && <p className={styles.groupTitle}>{group.title}</p>}
        {group.note && <p className={styles.groupNote}>{group.note}</p>}
        {group.options.map((opt) => {
          const off = shareOptionNeedsScene(opt.key) && !value.allowScene;
          return (
            <label key={opt.key} className={`${styles.option} ${off ? styles.optionOff : ''}`}>
              <input
                type="checkbox"
                className={styles.checkbox}
                checked={value[opt.key] && !off}
                disabled={off}
                onChange={(e) => onChange({ ...value, [opt.key]: e.target.checked })}
              />
              <div>
                <p className={styles.title}>{opt.title}</p>
                <p className={styles.hint}>
                  {off ? 'Point clouds are shown only in the Scene — allow opening it first' : opt.hint}
                </p>
              </div>
            </label>
          );
        })}
      </div>
    ))}
  </div>
);

export default ShareAccessOptions;
